/**
 * Date helpers of the Application Access block form. A block is dated by the
 * India calendar day and stored as its last day, so "days" on the form is
 * only another way of typing that date.
 */
const BLOCK_TIME_ZONE = "Asia/Kolkata";
const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** Today's date in India as YYYY-MM-DD. */
export function todayForBlock(): string {
  return new Date().toLocaleDateString("en-CA", { timeZone: BLOCK_TIME_ZONE });
}

/** The last day of a block that runs for `days` days from today. */
export function daysToUntil(days: number): string {
  const until = new Date(`${todayForBlock()}T00:00:00Z`);
  until.setUTCDate(until.getUTCDate() + days);
  return until.toISOString().slice(0, 10);
}

/** How many days from today a block ending on `until` runs. */
export function untilToDays(until: string): number {
  const from = new Date(`${todayForBlock()}T00:00:00Z`).getTime();
  const to = new Date(`${until}T00:00:00Z`).getTime();
  return Math.round((to - from) / MS_PER_DAY);
}

/** 2026-10-20 → 20 Oct 2026. */
export function formatBlockDate(until: string): string {
  return new Date(`${until}T00:00:00Z`).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}
